export const SET_TECH_BY_TYPE = 'SET_TECH_BY_TYPE'
export const SET_TECH_TOTAL_BY_TYPE = 'SET_TECH_TOTAL_BY_TYPE'
export const CLEAR_TECH_BY_TYPE = 'CLEAR_TECH_BY_TYPE'
export const CLEAR_TECH_TOTAL_BY_TYPE = 'CLEAR_TECH_TOTAL_BY_TYPE'
